import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

const Icon = ({ primary, secondary, opacity, className }) => (
  <i
    key={uuidv4()}
    className={`icon duotone-${className}`}
    style={{
      '--primary': primary,
      '--secondary': secondary,
      '--opacity': opacity,
    }}
  />
);

Icon.defaultProps = {
  primary: null,
  secondary: null,
  opacity: null,
  className: '',
};

Icon.propTypes = {
  primary: PropTypes.string,
  secondary: PropTypes.string,
  opacity: PropTypes.string,
  className: PropTypes.string,
};

const icons = [
  'Accounts',
  'Contacts',
  'Dashboard',
  'Health',
  'Integrations',
  'Lifecycle',
  'Notes',
  'Organisations',
  'Pipelines',
  'Scenarios',
  'Segments',
  'Setup',
  'Task',
  'UserManagement',
  'Premium',
  'EmailTemplate',
  'Communications',
  'Surveys',
];

const Duotones = {};

icons?.forEach((iconName) => {
  Duotones[iconName] = ({ primary, secondary, opacity }) => (
    <Icon
      primary={primary}
      secondary={secondary}
      opacity={opacity}
      className={iconName.toLowerCase()}
    />
  );
});

export const {
  Accounts,
  Contacts,
  Dashboard,
  Health,
  Integrations,
  Lifecycle,
  Notes,
  Organisations,
  Pipelines,
  Scenarios,
  Segments,
  Setup,
  Task,
  UserManagement,
  Premium,
  EmailTemplate,
  Communications,
  Surveys,
} = Duotones;
